var getPath = function (name, size, pathsMap) { var _a; return ((_a = pathsMap === null || pathsMap === void 0 ? void 0 : pathsMap[size]) === null || _a === void 0 ? void 0 : _a[name]) || ''; };
var getPathName = function (_a) {
    var hasTopAddons = _a.hasTopAddons, hasBottomAddons = _a.hasBottomAddons, hasIndicator = _a.hasIndicator;
    if (hasBottomAddons) {
        if (hasTopAddons) {
            return 'topBottom';
        }
        if (hasIndicator) {
            return 'indicatorBottom';
        }
        return 'bottom';
    }
    if (hasTopAddons) {
        return 'top';
    }
    if (hasIndicator) {
        return 'indicator';
    }
    return 'none';
};

export { getPath, getPathName };
